import React, { useRef } from "react";
import ReactToPrint from "react-to-print";

export const ComponentToPrint = React.forwardRef((props, ref) => {
  return <div ref={ref}>My cool content here!</div>;
});
